<template>
    <div class="home">
        <div class="content">
            <div class="top" @click="back"></div>
            <div class="bottom">
                <div class="navigationBar">
                    <div class="bar">Hydrogen compressor</div>
                </div>
                <div class="contentByHydrogen">
                    <img src="../assets/compressorPages/tu1-1.png" alt="" @click="toDetails(1.1)">
                    <img src="../assets/compressorPages/tu1-2.png" alt="" @click="toDetails(1.2)">
                    <img src="../assets/compressorPages/tu1-3.png" alt="" @click="toDetails(1.3)">
                    <img src="../assets/compressorPages/tu1-4.png" alt="" @click="toDetails(1.4)">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "HydrogenCompressor",
    components: {},
    data() {
        return {
        };
    },
    mounted() {},
    methods: {
        back() {
            this.$router.push({
                path: "/about",
                query: {
                    btnLinks: '2'
                }
            });
        },
        toDetails(e){
            this.$router.push({
            path: "/details",
            query: {
                id:e
            }
        });
        }
    },
    created() {},
};
</script>

<style scoped>
.home {
    background-position: center center;
    background-repeat: no-repeat;
    background-attachment: fixed;
    background-size: cover;
    height: 100vh;
    background-image: url(../assets/bg2.png);
    padding: 20px;
    box-sizing: border-box;
    overflow-y: scroll;
}
.content .top {
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
    width: 40px;
    height: 40px;
    background-image: url(../assets/back.png);
}
.content .top:hover {
    background-image: url(../assets/backHover.png);
}
.content .bottom {
    height: 80vh;
    display: flex;
    box-sizing: border-box;
}
.content .bottom .navigationBar {
    width:30%;
    height: 80vh;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
}
.content .bottom .navigationBar .bar {
    width: 40%;
    height: 50px;
    padding: 10px 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    font-size: 18px;
    line-height: 25px;
    border-radius: 10px;
    border: 1.5px solid #ffc000;
    color: #ffc000;
    background: rgba(0,0,0,0);
}
.content .bottom .contentByHydrogen {
    width:70%;
    height: 80vh;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
}
.content .bottom .contentByHydrogen img {
    width:200px;
    height:200px;
    margin-bottom:25px;
    margin-right: 25px;
}   
</style>
